import { Base } from "@/atoms-react/text/Text.react";
import { Info } from "@/atoms-react/text/Text.react";
import "./index.css";

export const StoreButtons = ({
  theme = "apple-btn",
  src,
  className
}: {
  theme?: string | undefined;
  src: string;
  className: string;
}) => {
  const text = theme === "apple-btn" ? "App Store" : "Google Store";

  return (
    <a
      href={src}
      target="_blank"
      rel="noopener noreferrer" // Added for security reasons
      className={`store-btns market-btn dark:bg-slate-800 dark:hover:bg-slate-900 ${theme} ${className} dark:text-black`}
      role="button"
    >
      <Info className="market-button-subtitle">Download on the</Info>
      <Base className="market-button-title dark:text-black">{text}</Base>
    </a>
  );
};
